// ── Product page swatches ──
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.color-swatch');
  if (!swatch) return;
  if (swatch.closest('.card-swatches')) return;
  onSwatchClick(swatch);
});

function onSwatchClick(swatch) {
  var fieldset = swatch.closest('fieldset');
  if (!fieldset) return;

  var value = swatch.dataset.optionValue;

  fieldset.querySelectorAll('.color-swatch').forEach(function (s) {
    s.classList.remove('active');
    s.setAttribute('aria-pressed', 'false');
    s.removeAttribute('aria-current');
  });
  swatch.classList.add('active');
  swatch.setAttribute('aria-pressed', 'true');
  swatch.setAttribute('aria-current', 'true');

  var selectedLabel = fieldset.querySelector('[data-selected-value]');
  if (selectedLabel) {
    selectedLabel.textContent = value;
  }

  var radios = fieldset.querySelectorAll('.css-swatch__hidden-radios input[type="radio"]');
  radios.forEach(function (radio) {
    if (radio.value === value) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      radio.checked = false;
    }
  });
}

// ── Collection card swatches ──
function initCardSwatches() {
  document.querySelectorAll('.card-swatches .color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      changeCardImage(swatch);
    }, true);
  });
}

function changeCardImage(swatch) {
  var card = swatch.closest('.card-wrapper');
  if (!card) return;

  card.querySelectorAll('.card-swatches .color-swatch').forEach(function(s) {
    s.classList.remove('active');
  });
  swatch.classList.add('active');

  var url = swatch.dataset.url;
  if (!url) return;

  var variantId = url.split('variant=')[1];
  if (!variantId) return;

  fetch('/variants/' + variantId + '.js')
    .then(function(r) { return r.json(); })
    .then(function(variant) {
      if (!variant.featured_image) return;
      var imgUrl = variant.featured_image.src;

      var cardImg = card.querySelector('.card__media img');
      if (cardImg) {
        cardImg.src = imgUrl;
        cardImg.srcset = imgUrl;
      }
    });
}

// ── Size guide link ──
document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href*="size-guide"], a[href*="size_guide"]');
  if (!link) return;
  e.preventDefault();
  var thumbnails = document.querySelectorAll('.product__media-list .thumbnail-list__item, .thumbnail-list button');
  if (thumbnails.length === 0) return;
  var lastThumb = thumbnails[thumbnails.length - 1];
  lastThumb.click();
  lastThumb.scrollIntoView({ behavior: 'smooth' });
});

// ── Init ──
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCardSwatches);
} else {
  initCardSwatches();
}